// extracted by mini-css-extract-plugin
module.exports = {"contentVideoDisplayWrapper":"u1","contentVideoDisplayImage":"u2","playButtonWrapper":"u3","playButton":"u4"};